(() => {
  'use strict';

  if (window.PWCartChoiceGroupsV2Loaded) return;
  window.PWCartChoiceGroupsV2Loaded = true;

  let timer = null;

  const normalize = (value) => String(value || '').trim().toLowerCase();
  const titleOf = (input) => normalize(input && input.dataset.pwServiceTitle);
  const cardOf = (input) => input && input.closest('.pw-service-card');
  const variants = (group) => Array.from(group.querySelectorAll('.pw-service-choice-variants .pw-service-input'));

  const make = (tag, className = '', text = '') => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };

  const priceOf = (input) => {
    if (!input) return '';
    if (input.dataset.pwChoicePrice) return input.dataset.pwChoicePrice;
    const card = cardOf(input);
    const price = card && card.querySelector('.pw-service-price');
    return price ? price.textContent.trim() : '';
  };

  const valueOf = (input) => String(input && (input.dataset.pwChoiceValue || input.dataset.pwServiceVariant) || '');

  const prepare = (card, value) => {
    if (!card) return null;
    const input = card.querySelector('.pw-service-input[data-pw-service-variant]');
    if (!input) return null;

    card.classList.add('pw-service-card--choice-variant');
    card.setAttribute('aria-hidden', 'true');
    input.dataset.pwChoiceValue = String(value || input.dataset.pwServiceVariant || '');
    input.dataset.pwChoicePrice = priceOf(input);
    return input;
  };

  const buildMain = (title, description, price) => {
    const main = make('label', 'pw-service-choice-main');
    const enable = make('input', 'pw-service-choice-enable');
    enable.type = 'checkbox';
    enable.dataset.pwChoiceEnable = '';

    const copy = make('span', 'pw-service-choice-copy');
    copy.append(make('strong', '', title), make('span', '', description));

    const priceNode = make('span', 'pw-service-choice-price', price || '');
    priceNode.dataset.pwChoicePrice = '';
    main.append(enable, copy, priceNode);
    return main;
  };

  const buildStacking = (root) => {
    if (root.querySelector('[data-pw-choice-generated="stacking-v2"]')) return;

    const cards = Array.from(root.querySelectorAll('.pw-service-group--washing .pw-service-grid > .pw-service-card')).filter((card) => {
      const input = card.querySelector('.pw-service-input[data-pw-service-title]');
      const title = titleOf(input);
      return title.includes('tussenstuk') && title.includes('wasmachine') && (title.includes('wit') || title.includes('zwart'));
    });
    if (!cards.length) return;

    const whiteCard = cards.find((card) => titleOf(card.querySelector('.pw-service-input')).includes('wit')) || null;
    const blackCard = cards.find((card) => titleOf(card.querySelector('.pw-service-input')).includes('zwart')) || null;
    const white = prepare(whiteCard, 'white');
    const black = prepare(blackCard, 'black');
    const first = white || black;
    const anchor = whiteCard || blackCard;
    if (!first || !anchor || !anchor.parentNode) return;

    const group = make('div', 'pw-service-choice-group');
    group.dataset.pwChoiceGroup = '';
    group.dataset.pwChoiceKind = 'binary';
    group.dataset.pwChoiceGenerated = 'stacking-v2';
    group.append(buildMain('Tussenstuk wasmachine/droger', 'Voor een veilige en nette stapelopstelling.', priceOf(first)));

    const options = make('div', 'pw-service-choice-options');
    options.dataset.pwChoiceOptions = '';
    options.hidden = true;

    if (white && black) {
      options.append(make('span', 'pw-service-choice-option-label', 'Kleur'));
      const binary = make('div', 'pw-binary-choice');
      binary.append(make('span', '', 'Wit'));

      const toggleLabel = make('label', 'pw-binary-toggle');
      const toggle = make('input');
      toggle.type = 'checkbox';
      toggle.dataset.pwChoiceToggle = '';
      toggle.setAttribute('aria-label', 'Schakel tussen wit en zwart');
      const track = make('span', 'pw-binary-toggle__track');
      track.setAttribute('aria-hidden', 'true');
      toggleLabel.append(toggle, track);

      binary.append(toggleLabel, make('span', '', 'Zwart'));
      options.append(binary);
    } else {
      options.append(make('span', 'pw-service-choice-single', white ? 'Kleur: wit' : 'Kleur: zwart'));
    }
    group.append(options);

    const hidden = make('div', 'pw-service-choice-variants');
    hidden.setAttribute('aria-hidden', 'true');
    group.append(hidden);

    anchor.parentNode.insertBefore(group, anchor);
    if (whiteCard) hidden.append(whiteCard);
    if (blackCard) hidden.append(blackCard);
  };

  const buildGas = (root) => {
    if (!root || root.querySelector('[data-pw-choice-generated="gas-v2"]')) return;
    const oldOptions = root.querySelector('.pw-gas-options');
    if (!oldOptions) return;

    const cards = Array.from(oldOptions.querySelectorAll('.pw-service-card'));
    const prepared = cards.map((card) => {
      const input = card.querySelector('.pw-service-input[data-pw-service-variant]');
      return prepare(card, input && input.dataset.pwServiceVariant);
    }).filter(Boolean);
    if (!prepared.length) return;

    const group = make('div', 'pw-service-choice-group');
    group.dataset.pwChoiceGroup = '';
    group.dataset.pwChoiceKind = 'select';
    group.dataset.pwChoiceGenerated = 'gas-v2';
    group.append(buildMain('Gasslang toevoegen', 'Kies één passende gasslang voor uw apparaat.', priceOf(prepared[0])));

    const options = make('div', 'pw-service-choice-options');
    options.dataset.pwChoiceOptions = '';
    options.hidden = true;

    const label = make('label', 'pw-service-choice-select-label');
    label.append(make('span', '', 'Type en lengte'));
    const select = make('select', 'pw-service-choice-select');
    select.dataset.pwChoiceSelect = '';
    prepared.forEach((input) => {
      const option = make('option');
      option.value = String(input.dataset.pwServiceVariant || '');
      option.dataset.pwChoicePrice = priceOf(input);
      const title = String(input.dataset.pwServiceTitle || 'Gasslang');
      option.textContent = priceOf(input) ? `${title} — ${priceOf(input)}` : title;
      select.append(option);
    });
    label.append(select);
    options.append(label);
    group.append(options);

    const hidden = make('div', 'pw-service-choice-variants');
    hidden.setAttribute('aria-hidden', 'true');
    cards.forEach((card) => hidden.append(card));
    group.append(hidden);

    const question = root.querySelector('.pw-gas-choice__question');
    if (question) question.hidden = true;
    oldOptions.replaceWith(group);
  };

  const rank = (node) => {
    if (node.matches('[data-pw-choice-generated="stacking-v2"]')) return 50;
    const input = node.querySelector && node.querySelector('.pw-service-input[data-pw-service-title]');
    const title = titleOf(input);
    if (title.includes('trekschakelaar')) return 10;
    if (title.includes('stroomsnoer')) return 20;
    if (title.includes('afvoerslang')) return 30;
    if (title.includes('y-splitter')) return 40;
    return 100;
  };

  const sortWashing = (root) => {
    root.querySelectorAll('.pw-service-group--washing .pw-service-grid').forEach((grid) => {
      const current = Array.from(grid.children);
      const ordered = current.slice().sort((a, b) => rank(a) - rank(b));
      const changed = ordered.some((child, index) => current[index] !== child);
      if (!changed) return;
      ordered.forEach((child) => grid.append(child));
    });
  };

  const availableVariants = (group) => variants(group).filter((input) => {
    const card = cardOf(input);
    return card && !card.hidden;
  });

  const preferred = (group) => {
    const available = availableVariants(group);
    const pool = available.length ? available : variants(group);
    const selected = pool.find((input) => input.checked);
    if (selected) return selected;

    if (group.dataset.pwChoiceKind === 'select') {
      const select = group.querySelector('[data-pw-choice-select]');
      return pool.find((input) => String(input.dataset.pwServiceVariant || '') === String(select && select.value || '')) || pool[0] || null;
    }

    const toggle = group.querySelector('[data-pw-choice-toggle]');
    const wanted = toggle && toggle.checked ? 'black' : 'white';
    return pool.find((input) => valueOf(input) === wanted) || pool[0] || null;
  };

  const dispatch = (input, checked) => {
    if (!input || input.checked === checked) return;
    input.checked = checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const choose = (group, target, enabled) => {
    variants(group).forEach((input) => dispatch(input, Boolean(enabled && input === target)));
  };

  const syncGroup = (group) => {
    const all = variants(group);
    const available = availableVariants(group);
    group.hidden = Boolean(all.length && !available.length);

    const selected = all.find((input) => input.checked) || null;
    const enable = group.querySelector('[data-pw-choice-enable]');
    const options = group.querySelector('[data-pw-choice-options]');
    if (enable) enable.checked = Boolean(selected);
    if (options) options.hidden = !selected;

    if (group.dataset.pwChoiceKind === 'select') {
      const select = group.querySelector('[data-pw-choice-select]');
      if (select && selected) select.value = String(selected.dataset.pwServiceVariant || '');
    } else {
      const toggle = group.querySelector('[data-pw-choice-toggle]');
      if (toggle && selected) toggle.checked = valueOf(selected) === 'black';
    }

    const price = group.querySelector('[data-pw-choice-price]');
    const priceInput = selected || preferred(group);
    if (price && priceInput && priceOf(priceInput)) price.textContent = priceOf(priceInput);
  };

  const syncAll = () => {
    document.querySelectorAll('.pw-services--extras').forEach((root) => {
      buildStacking(root);
      sortWashing(root);
    });
    document.querySelectorAll('.pw-gas-choice').forEach(buildGas);
    document.querySelectorAll('[data-pw-choice-group]').forEach(syncGroup);
  };

  const schedule = (delay = 40) => {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      timer = null;
      syncAll();
    }, delay);
  };

  const toggleInput = (input) => {
    if (!(input instanceof HTMLInputElement)) return;
    input.disabled = false;
    input.removeAttribute('disabled');
    input.removeAttribute('aria-disabled');

    if (input.type === 'radio') {
      if (!input.checked) dispatch(input, true);
    } else {
      dispatch(input, !input.checked);
    }
  };

  /* Extra diensten gebruiken één expliciete klikroute.
     Hiermee kan de hele kaart worden gekozen zonder dubbele label-toggle. */
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const extras = target.closest('.pw-services--extras');
    if (!extras) return;

    if (target.closest('input, select, option, button, a')) return;

    const choiceMain = target.closest('.pw-service-choice-main');
    if (choiceMain && extras.contains(choiceMain)) {
      const input = choiceMain.querySelector('.pw-service-choice-enable');
      if (!input) return;
      event.preventDefault();
      event.stopPropagation();
      toggleInput(input);
      return;
    }

    const card = target.closest('.pw-service-card');
    if (!card || !extras.contains(card) || card.hidden || card.closest('.pw-service-choice-variants')) return;

    const input = card.querySelector('.pw-service-input');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    toggleInput(input);
  }, true);

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.matches('[data-pw-product-service-level]')) {
      schedule(0);
      return;
    }

    const group = target.closest('[data-pw-choice-group]');
    if (!group) return;

    if (target.matches('[data-pw-choice-enable]')) {
      const chosen = preferred(group);
      choose(group, chosen, target.checked);
      syncGroup(group);
      return;
    }

    if (target.matches('[data-pw-choice-select]')) {
      const chosen = variants(group).find((input) => String(input.dataset.pwServiceVariant || '') === target.value) || preferred(group);
      const enable = group.querySelector('[data-pw-choice-enable]');
      if (enable && enable.checked) choose(group, chosen, true);
      syncGroup(group);
      return;
    }

    if (target.matches('[data-pw-choice-toggle]')) {
      const wanted = target.checked ? 'black' : 'white';
      const chosen = variants(group).find((input) => valueOf(input) === wanted) || preferred(group);
      const enable = group.querySelector('[data-pw-choice-enable]');
      if (enable && enable.checked) choose(group, chosen, true);
      syncGroup(group);
      return;
    }

    if (target.matches('.pw-service-input')) syncGroup(group);
  }, true);

  document.addEventListener('on:cart:change', () => schedule(80));
  document.addEventListener('shopify:section:load', () => schedule(0));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }

  new MutationObserver(() => schedule(30)).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
